(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ox-shopping-perks"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-ox-coupon]')) return;
  event.preventDefault();
  const input = form.elements.namedItem('discount');
  if (!(input instanceof HTMLInputElement)) return;
  const code = input.value.trim();
  if (!code) {
    input.setCustomValidity('Enter a coupon code.');
    input.reportValidity();
    input.addEventListener('input', () => input.setCustomValidity(''), { once: true });
    return;
  }
  const root = (form.dataset.root || '/').replace(/\/?$/, '/');
  const destination = form.dataset.redirect || '/collections/all';
  const currentPath = window.location.pathname + window.location.search;
  const redirect = decodeURIComponent(currentPath.startsWith(destination) ? currentPath : destination);
  window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect));
});
  } catch(e) { console.error(e); }
})();

})();
